import React from 'react';
import { WHY_COOLCLIMATE_SECTION } from './homePageConstants';

export const WhyCoolClimateSection: React.FC = () => (
  <section
    id="why-coolclimate"
    className="home-section home-section--accent home-why"
    aria-labelledby="why-coolclimate-heading"
  >
    <div className="home-section__container">
      <header className="home-section__header">
        <h2 id="why-coolclimate-heading" className="home-section__title">
          {WHY_COOLCLIMATE_SECTION.title}
        </h2>
      </header>
      <ul className="home-why__grid">
        {WHY_COOLCLIMATE_SECTION.items.map((item) => (
          <li key={item} className="home-why__item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  </section>
);
